export const formatRegions = (regionsList: string[]) => {
  if (!regionsList || !regionsList.length) return "";

  const formatter = new Intl.ListFormat("en", {
    style: "long",
    type: "conjunction",
  });
  const formattedRegions = formatter.format(regionsList);

  return `Valid for ${formattedRegions}.`;
};
